import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const bodyContainer = document.querySelector('body');
  const alertsBarWrapper = document.getElementById('alerts-bar');
  const alertsBar = document.querySelector('.alerts-bar__inner');
  let alertResizeObserver = alertsBarWrapper
    ? alertsBarWrapper.vtxAlertResizeObserver || null
    : null;
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    `${window.innerWidth - document.documentElement.clientWidth}px`
  );

  if (alertsBarWrapper && alertsBar) {
    bodyContainer.classList.add('alerts-bar-active');
    const swiper = new Swiper(alertsBar, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        prevEl: document.querySelector('.alert-controls .swiper-button-prev'),
        nextEl: document.querySelector('.alert-controls .swiper-button-next'),
      },
      a11y: {
        enabled: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        prevSlideMessage: _x(
          'Go to previous slide',
          'swiper accessibility',
          'vtx'
        ),
        nextSlideMessage: _x('Go to next slide', 'swiper accessibility', 'vtx'),
        paginationBulletMessage: _x(
          'Go to slide {{index}}',
          'swiper accessibility',
          'vtx'
        ),
      },
    });

    function updateBg() {
      const activeSlide = swiper.slides[swiper.activeIndex];
      const bgColor = activeSlide.getAttribute('data-bg');
      if (bgColor) {
        alertsBarWrapper.style.backgroundColor = bgColor;
      }
    }

    swiper.on('slideChange', updateBg);
    updateBg();
  }

  const closeAlert = document.querySelector('.alerts-bar__close-button');

  if (closeAlert) {
    closeAlert.addEventListener('click', function () {
      closeAlertBar();
    });
  }

  function heightAlertBar() {
    if (!alertsBarWrapper || !alertsBarWrapper.isConnected) {
      return;
    }

    const alertHeight = alertsBarWrapper.offsetHeight;
    alertsBarWrapper.style.setProperty('--AlertHeight', alertHeight + 'px');
    document.documentElement.style.setProperty(
      '--AlertHeight',
      alertHeight + 'px'
    );
  }

  function closeAlertBar() {
    if (alertResizeObserver) {
      alertResizeObserver.disconnect();
    }
    document.querySelector('.alerts-bar-swiper').remove();
    bodyContainer.classList.remove('alerts-bar-active');
    document.documentElement.style.removeProperty('--AlertHeight');
  }

  heightAlertBar();

  // Font loading and wrapped messages can change the height after initialization.
  if (alertsBarWrapper && window.ResizeObserver && !alertResizeObserver) {
    alertResizeObserver = new ResizeObserver(heightAlertBar);
    alertResizeObserver.observe(alertsBarWrapper);
  }

  window.addEventListener('resize', function () {
    heightAlertBar();
  });
});
